import {Location, NavigateFunction} from 'react-router-dom';

import {isProd} from 'app/utils/envUtils';

export const ROOT_URL = isProd ? 'https://app.lens.tech' : 'http://localhost:9999';

export function matchInHash(location: Location, regexp: RegExp) {
  const {hash} = location;

  const hashBits = hash ? hash.split('|').map(decodeURIComponent) : [];

  return hashBits.reduce((acc: null | RegExpMatchArray, bit) => bit.match(regexp) || acc, null);
}

/**
 * Updates the hash in the URL using React Router v6's navigate function.
 */
export function updateHash(
  navigate: NavigateFunction,
  location: Location,
  regexp: RegExp,
  newHashBit: string | null,
  pushToHistory: boolean = false
) {
  const {hash} = location;

  let hashBits = hash ? hash.split('|').map(decodeURIComponent) : [];
  hashBits = hashBits.filter((b) => !b.match(regexp));

  if (newHashBit) {
    hashBits.push(newHashBit);
  }

  const newHash = hashBits.map(encodeURIComponent).join('|');
  const newPath = location.pathname + location.search + (newHash ? `#${newHash}` : '');

  navigate(newPath, {replace: !pushToHistory});
}
